export const iconFontAwesomeSocialRetweet = (
	<i className="fa-solid fa-retweet"></i>
);
